import { createSlice, current } from "@reduxjs/toolkit";
import { getAttendancList, generateAttendance, getDashboard } from "./attendanceAction";

const initialState = {
    attendanceDashboard: null,
    attendanceData: [],
    attendanceMeta: { totalRecords: 0, totalpages: 0, currentPage: 1, pageSize: 10, },
    loading: false,
    error: null,
}

const attendanceSlice = createSlice({   
    name: "attendance",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(getDashboard.pending, (state) => {
                state.loading = true;
            })

            .addCase(getDashboard.fulfilled, (state, action) => {
                state.loading = false;
                state.attendanceDashboard = action.payload.data;
            })

            .addCase(getDashboard.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(getAttendancList.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAttendancList.fulfilled, (state, action) => {

                state.loading = false;
                const response = action.payload.data;
                state.attendanceData = response.data || [];
                state.attendanceMeta = {
                    totalRecords: response.totalRecords ?? 0,
                    totalPages: response.totalPages ?? 0,
                    currentPage: response.currentPage ?? 0,
                    PageSize: response.PageSize ?? 0,
                };
            })

            .addCase(getAttendancList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(generateAttendance.pending, (state) => {
                state.loading = true;
            })

            .addCase(generateAttendance.fulfilled, (state) => {
                state.loading = false;
            })

            .addCase(generateAttendance.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export const { clearAttendanceData } = attendanceSlice.actions;
export default attendanceSlice.reducer;